import { render, staticRenderFns } from "./ConfirmClearCustomer.vue?vue&type=template&id=29477fad&scoped=true"
import script from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts"
export * from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29477fad",
  null
  
)

export default component.exports